"use client";

import React from "react";
import { ArrowUpRight, Wrench } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
interface CategoryItem {
  id: string;
  name: string;
  count: string;
  spec: string;
  href: string;
  image: string;
  srcset: string;
  sizes: string;
  alt: string;
}
const categories: CategoryItem[] = [{
  id: "hand-tools",
  name: "Hand Tools",
  count: "04 UNITS",
  spec: "SPEC: CR-V STEEL",
  href: "/ShopPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_hand_tools.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_hand_tools.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_hand_tools.png-wvc-sizes",
  alt: "Precision chrome vanadium hand tools and socket set"
}, {
  id: "power-tools",
  name: "Power Tools",
  count: "05 UNITS",
  spec: "SPEC: BRUSHLESS 20V",
  href: "/ShopPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_power_tools.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_power_tools.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_power_tools.png-wvc-sizes",
  alt: "Heavy duty industrial brushless power drill and impact driver"
}, {
  id: "air-pneumatics",
  name: "Air & Pneumatics",
  count: "03 UNITS",
  spec: "SPEC: 150 PSI MAX",
  href: "/ShopPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_pneumatics.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_pneumatics.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_pneumatics.png-wvc-sizes",
  alt: "Pneumatic air impact wrench and high pressure hose fitting"
}, {
  id: "workshop-storage",
  name: "Workshop Storage",
  count: "03 UNITS",
  spec: "SPEC: 18-GAUGE STEEL",
  href: "/ShopPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_storage.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_storage.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_storage.png-wvc-sizes",
  alt: "Heavy gauge rolling tool cabinet and modular chest"
}, {
  id: "automotive-lifting",
  name: "Automotive Lifting",
  count: "03 UNITS",
  spec: "SPEC: 4-TON RATED",
  href: "/ShopPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_lifting.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_lifting.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_lifting.png-wvc-sizes",
  alt: "Hydraulic floor jack and solid steel jack stands"
}, {
  id: "diagnostic-gear",
  name: "Diagnostic Gear",
  count: "02 UNITS",
  spec: "SPEC: OBD-II CANBUS",
  href: "/ShopPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_diagnostics.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_diagnostics.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_diagnostics.png-wvc-sizes",
  alt: "Digital diagnostic scanner and automotive multimeter"
}, {
  id: "welding-cutting",
  name: "Welding & Cutting",
  count: "03 UNITS",
  spec: "SPEC: 200A MIG/TIG",
  href: "/ShopPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_welding.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_welding.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_welding.png-wvc-sizes",
  alt: "Multi-process inverter welding unit with auto-darkening mask"
}, {
  id: "machining-lathes",
  name: "Machining & Lathes",
  count: "02 UNITS",
  spec: "SPEC: 0.001MM TOLERANCE",
  href: "/ShopPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_machining.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_machining.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_machining.png-wvc-sizes",
  alt: "Precision metal bench lathe with machined cutting bit"
}, {
  id: "safety-protection",
  name: "Safety & PPE",
  count: "03 UNITS",
  spec: "SPEC: ANSI Z87.1",
  href: "/ShopPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_safety.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_safety.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_safety.webp-wvc-sizes",
  alt: "Industrial impact eye protection and Kevlar reinforced gloves"
}, {
  id: "garage-lighting",
  name: "Garage Lighting",
  count: "02 UNITS",
  spec: "SPEC: 10,000 LUMENS",
  href: "/ShopPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_lighting.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_lighting.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_lighting.png-wvc-sizes",
  alt: "High-output LED shop bay light fixture and magnetic task pod"
}, {
  id: "maintenance-fluids",
  name: "Maintenance Gear",
  count: "03 UNITS",
  spec: "SPEC: SYNTHETIC GRADE",
  href: "/ShopPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_maintenance.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_maintenance.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1787497/img/category_maintenance.png-wvc-sizes",
  alt: "High performance synthetic lubricants and fluid extraction pump"
}];
export default function Categories() {
  const shouldReduceMotion = useReducedMotion();
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: shouldReduceMotion ? 0 : 0.06
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: shouldReduceMotion ? 1 : 0,
      y: shouldReduceMotion ? 0 : 14
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.24,
        ease: [0.16, 1, 0.3, 1]
      }
    }
  };
  return <section id="featured-categories" data-nav="dark" className="bg-background text-foreground border-b border-border py-16 md:py-20 lg:py-24">
      <div className="mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-12">
        {/* Section Header */}
        <div className="mb-10 flex flex-col gap-6 md:mb-14 md:flex-row md:items-end md:justify-between">
          <div className="flex flex-col gap-3">
            {/* Precision Technical Tag */}
            <div className="flex items-center gap-2">
              <Badge variant="outline" className="rounded-none border-border bg-muted/40 font-mono text-xs uppercase tracking-widest text-muted-foreground">
                <Wrench className="size-3 text-primary" />
                Catalog Departments
              </Badge>
              <span className="font-mono text-xs text-muted-foreground">
                [11 SECTORS]
              </span>
            </div>

            {/* Title with Precision Spec Rule bar */}
            <div className="flex items-center gap-3">
              <div className="h-8 w-[3px] shrink-0 bg-primary md:h-10" />
              <h2 className="font-serif text-3xl font-bold tracking-tight uppercase sm:text-4xl lg:text-5xl">
                Find gear by workshop category
              </h2>
            </div>
            <p className="max-w-2xl text-base text-muted-foreground md:text-lg">
              Browse 33 professional tools and heavy-duty shop units across 11
              dedicated trade disciplines.
            </p>
          </div>

          <div className="shrink-0">
            <Button asChild variant="outline" className="group rounded-none border-border font-serif uppercase tracking-wider text-foreground hover:border-primary hover:bg-muted/30">
              <Link to="/ShopPage">
                <span>View full catalog</span>
                <ArrowUpRight className="size-4 text-primary transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </Link>
            </Button>
          </div>
        </div>

        {/* Categories Grid */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.15
      }} className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((cat, i) => <motion.div key={cat.id} data-index={i} variants={cardVariants} className="h-full">
              <Link to={cat.href} className="group relative flex h-full flex-col justify-between overflow-hidden rounded-none border border-border bg-card p-5 transition-[border-color,box-shadow] duration-200 hover:border-primary hover:shadow-lg">
                {/* Image Container with Dark Gradient Overlay */}
                <div className="relative mb-5 aspect-[4/3] w-full overflow-hidden border border-border/60 bg-muted">
                  <img src={cat.image} data-wvc-srcset={cat.srcset} data-wvc-sizes={cat.sizes} alt={cat.alt} loading="lazy" decoding="async" className="h-full w-full object-cover object-center transition-transform duration-300 group-hover:scale-[1.03]" />
                  {/* Subtle Dark Industrial Vignette */}
                  <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/20 to-transparent pointer-events-none" />

                  {/* Monospace Unit Count Tag */}
                  <div className="absolute top-2.5 right-2.5">
                    <span className="border border-border/80 bg-background/90 px-2 py-0.5 font-mono text-[11px] font-semibold tracking-wider text-muted-foreground uppercase backdrop-blur-xs">
                      {cat.count}
                    </span>
                  </div>
                </div>

                {/* Content & Metadata */}
                <div className="flex flex-col gap-2">
                  <div className="flex items-center justify-between gap-2">
                    <h3 className="font-serif text-xl font-bold uppercase tracking-wide text-card-foreground group-hover:text-primary transition-colors">
                      {cat.name}
                    </h3>
                    <div className="flex size-7 shrink-0 items-center justify-center border border-border bg-muted/40 text-muted-foreground transition-colors group-hover:border-primary group-hover:bg-primary group-hover:text-primary-foreground">
                      <ArrowUpRight className="size-4" />
                    </div>
                  </div>

                  <p className="font-mono text-xs tracking-wider text-muted-foreground uppercase">
                    {cat.spec}
                  </p>
                </div>

                {/* Bottom 3px Precision Accent Indicator */}
                <div className="mt-5 h-[3px] w-full bg-border transition-colors duration-200 group-hover:bg-primary" />
              </Link>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}